import { loadScript } from '@mtfe/sweet-utils';

export default function loadKNB() {
    return new Promise((resolve, reject) => {
        if (window.KNB) {
            // 如果 KNB 已经存在，直接返回它
            resolve(window.KNB);
        } else {
            // 动态加载 KNB 脚本
            loadScript('//s0.meituan.net/bs/knb/v1.8.3/knb.js', {}, function (err, script) {
                if (err) {
                    // 处理错误并拒绝 Promise
                    reject(err);
                } else {
                    // 加载成功，返回 KNB 对象
                    resolve(window.KNB);
                }
            });
        }
    });
}
